import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button, Tooltip, } from 'antd';

import { Application } from "@yulintu/freesia-bootstrap";

import useDesigner from "../hooks/useDesigner";
import useDesignerMessage from "../hooks/useDesignerMessage";

export default function Addon(props) {

    const designer = useDesigner();

    return <>
        <Tooltip title="缩放到全图" placement="bottom">
            <Button
                onClick={e => designer.flyToPaper()}
            >
                <Application.SystemSvgIcon type="quantu" />
            </Button>
        </Tooltip>
    </>
}